
import $store from '@/store';
import Vue from 'vue';

export default {

	is(name) {
		if (typeof($store.state.cache[name]) != "undefined") return true;
		return false;
	},

	get(name) {
		return $store.state.cache[name] || {};
	},

	set(name, value) {
		Vue.set($store.state.cache, name, value);
	},


	set_loading(name, value) {
		Vue.set($store.state.cache, "__" + name + "__loading__", value); 
	},

	get_loading(name) {
		return $store.state.cache["__" + name + "__loading__"];
	},

	watch_loading(name, cb) {
		$store.watch(
			(state) => state.cache["__" + name + "__loading__"],
			(value) => {
				cb(value);
			}
		);
	}


	// get(name, getter) {
	// 	var self = this;
	// 	if (typeof($store.state.cache[name]) == "undefined") {

	// 		function wait_for_value(vname) {
	// 			$store.watch(
 //        (state) => state.account,
 //        (value) => {
 //          if (typeof(value) != "undefined") {
 //            proceed();
 //          }
 //        }
 //      );
	// 		}

	// 		if (this.get_loading(name) === false) {
	// 			return $store.state.cache[name];
	// 		}

	// 		if (this.get_loading(name) === true) {
	// 			return wait_for_value($store.vname);
	// 		}

	// 		this.set_loading(name, true);

	// 		getter(function(value) {
	// 			Vue.set($store.state.cache, name, value);
	// 			self.set_loading(false);
	// 		});

	// 		return wait_for_value(name);

	// 	} else {
	// 		return $store.state.cache[name];
	// 	}
	// }

}